import { OrgId } from "@ollie-sports/models";
import { getBifrost } from "../services/bifrost.service";

export function useOrgTeams(p: { orgId: OrgId }) {
  const { data } = getBifrost().teams__client__getActiveOrgTeamsSubscription.useClientSubscription({ orgId: p.orgId });

  return data;
}
